import React from 'react';
import { ImagesProvider } from 'contexts/ImagesContext';
import TextField from 'components/fragments/TextField3/TextField';
const TextFieldComponent = (props) => (
  <ImagesProvider
    intro={false}
    r={require.context(
      'components/fragments/TextField/',
      true,
      /\.(png|jpe?g|svg|gif)$/
    )}
  >
    <TextField {...props} />
  </ImagesProvider>
);

export default TextFieldComponent;
